import React, { useEffect } from "react";
import { connect } from "react-redux";
import { NavLink } from "react-router-dom";
import Loader from "./../../../shared/loader";
import { fetchTaskStatuses } from "./ducks/actions";
import AddIcon from "../../icons/add";
import List from "./list";
import ScrollIntoView from "../../../shared/scroll-into-view/scroll-into-view";

function ListPropsContainer(props) {
  const filmId = props.match.params.filmId;
  const { fetchTaskStatuses, loadingTaskStatuses, taskStatuses, errors, readOnly } = props;

  useEffect(() => {
    fetchTaskStatuses(filmId);
  }, []);

  function renderLoading() {
    return <Loader />;
  }

  function renderTaskStatuss(taskStatuses, filmId) {
    return (
      <ScrollIntoView
        className="blade-menu"
        path="/films/:filmId/task-statuses"
        loading={loadingTaskStatuses}>
        <List taskStatuses={taskStatuses} filmId={filmId} />
        {!readOnly && !window.location.pathname.endsWith("add") && <NavLink
          to={`/films/${filmId}/task-statuses/add`}
          activeClassName={
            "is-active " + window.location.pathname.endsWith("add")
              ? "disabled"
              : ""
          }
          className="button is-transparent is-add">
          <AddIcon className="white-icon" />
          Add Task Status
        </NavLink>}
      </ScrollIntoView>
    );
  }

  return loadingTaskStatuses ? renderLoading() : renderTaskStatuss(taskStatuses, filmId);
}

function mapStateToProps(state) {
  const { taskStatuses, loadingTaskStatuses, errors, readOnly } = state.taskStatusesState.rootState;
  return { taskStatuses, loadingTaskStatuses, errors, readOnly };
}

export default connect(mapStateToProps, {
  fetchTaskStatuses
})(ListPropsContainer);
